// extracted by mini-css-extract-plugin
export var carrierIcon = "_wo-0";
export var carrierLogo = "_wo-1";
export var detailsSection = "_wo-2";